import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const bxApi = axios.create({
    baseURL: HOST_API + '/rest',
});

export default bxApi;
